import type { AlertColor } from "@mui/material";

import trialDaysRemaining from "~/helpers/trialDaysRemaining";

export type TrialBannerBucket = "critical" | "normal" | "warning";

export interface TrialBannerEscalation {
	bucket: TrialBannerBucket;
	labelCount?: number;
	labelKey: string;
	severity: AlertColor;
}

const CRITICAL_DAYS = 1;
const WARNING_DAYS = 7;

const trialBannerEscalation = (
	expiration: string | null | undefined,
	now: Date = new Date()
): TrialBannerEscalation => {
	if (!expiration) return { bucket: "normal", labelKey: "shell.trialBanner.label", severity: "info" };

	const days = trialDaysRemaining(expiration, now);

	if (days <= CRITICAL_DAYS) {
		return {
			bucket: "critical",
			labelKey: days <= 0 ? "shell.trialBanner.escalation.expiresToday" : "shell.trialBanner.escalation.endsOneDay",
			severity: "error"
		};
	}

	if (days <= WARNING_DAYS) {
		return {
			bucket: "warning",
			labelCount: days,
			labelKey: "shell.trialBanner.escalation.endsInDays",
			severity: "warning"
		};
	}

	return { bucket: "normal", labelCount: days, labelKey: "shell.trialBanner.remaining", severity: "info" };
};

export default trialBannerEscalation;
